import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  GetEnumValuesDto,
  GetPackageSaleByIdDto,
  GetPackageSalesWithPaginationDto,
  PaginatedListOfGetPackageSalesWithPaginationDto,
} from 'src/app/core/api/models';
import { PackageSalesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { RefreshMenuService } from 'src/app/core/services/refresh-menu.service';
import { MenuBtnComponent } from 'src/app/shared/global/menu-btn/menu-btn.component';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { ExpirationTypeDirective } from '../shared/expiration-type.directive';
import { PackageSalesFormComponent } from './package-sales-form/package-sales-form.component';

@Component({
  selector: 'app-package-sales',
  templateUrl: './package-sales.component.html',
  imports: [
    BaseIndexModule,
    MenuBtnComponent,
    PackageSalesFormComponent,
    ExpirationTypeDirective,
  ],
})
export class PackageSalesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.packageSales;

  /* Binding service endpoints */
  protected currentService = inject(PackageSalesService);
  paginationApiMethodName: string =
    this.currentService.packageSalesGetPackageSalesWithPagination.name;
  createGetApiMethodName: string =
    this.currentService.packageSalesCreateGet.name;
  auditApiMethodName: string =
    this.currentService.packageSalesGetPackageSalesAudit.name;
  deleteApiMethodName: string = this.currentService.packageSalesDelete.name;
  /* Binding service endpoints */

  modelWithPagination$: Observable<PaginatedListOfGetPackageSalesWithPaginationDto>;
  items$: Observable<Array<GetPackageSalesWithPaginationDto>>;
  formPageConfig: FormPageConfig<GetPackageSaleByIdDto> = {};
  isVisibleHelpForm;
  ExpirationType: GetEnumValuesDto[] = [];
  //#endregion

  constructor(public refreshMenuService: RefreshMenuService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      // this.pageConfig.isVisibleForm = true;
      // this.onCreate();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.packageOrganization
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('ExpirationType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.ExpirationType = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.id, name: 'id', hasSearch: true, type: 'number' },
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: this.localizer.active,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}expirationType`,
        name: 'expirationType',
        hasSearch: true,
        type: 'enum',
        enumName: 'ExpirationType',
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}expiration`,
        name: 'expiration',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `common.depositPrice`,
        name: 'depositPrice',
        hasSearch: true,
        needCurrency: true,
        type: 'number',
      },
      {
        title: `common.originalPrice`,
        name: 'originalPrice',
        hasSearch: true,
        needCurrency: true,
        type: 'number',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'date',
      },
    ];
  }

  //#region api methods

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .packageSalesUpdateGet({ PackageSaleId: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion
}
